export default __webpack_public_path__ + "static/media/title-icon.3eae184b.svg";